'use strict';

var isValidEthAddress = require('./is-valid-eth-address');

var io = require('./io.js');

module.exports = {
  io: io,
  isValidEthAddress: isValidEthAddress
};